module.exports = __webpack_public_path__ + "img/talent.07df8dcb.png";